import React, { useState } from 'react'
import axios from 'axios';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

function App() {
  const [data, setData] = useState({})
  const [location, setLocation] = useState()
  const[margin,setmargin]=useState("search_before");
  const changeStyle = () => {

      setmargin("search_after");
    
  };

  const url = `https://api.openweathermap.org/data/2.5/weather?q=${location}&units=metric&appid=895284fb2d2c50a520ea537456963d9c`

  const searchLocation = (event) => {
    if (event.key === 'Enter') {
      
      axios.get(url).then((response) => {
        setData(response.data)
        console.log(response.data)
      })
      setLocation('')
      changeStyle()
    }
  }


  return (
    <div className="app">
      
      <div className="container">

      <div className={margin} >
        <input
          value={location}
          onChange={
            event => setLocation(event.target.value)
            
          }
          onKeyPress={searchLocation}  
          placeholder='Enter Location'
          type="text" />
      </div>
        
      {data.name !== undefined &&
        <div className="top">
          <div className="location">
            <p>{data.name}</p>
          </div>
          <div className="temp">
            {data.main ? <h1>{data.main.temp.toFixed()}°C</h1> : null}
          </div>
          <div className="description">
            {data.weather ? <p>{data.weather[0].main}</p> : null}
          </div>
        </div>
        
      }

      {data.name !== undefined &&
          
          <div className="bottom">
            
            <div className="feels">
              {data.main ? <p className='bold'>{data.main.feels_like.toFixed()}°C</p> : null}
              <p>Feels Like</p>
            </div>
            <div className="humidity">
              {data.main ? <p className='bold'>{data.main.humidity}%</p> : null}
              <p>Humidity</p>
            </div>
            <div className="wind">
              {data.wind ? <p className='bold'>{data.wind.speed.toFixed()} KMPH</p> : null}
              <p>Wind Speed</p>
            </div>
          </div>

          
        }

        <div className="contacts">
          <p>Created by Arijit</p> 
        </div>

        <div className="links">
          
          <a className="linkedin" href='https://www.linkedin.com/in/arijit-saha-a671b81a0'><LinkedInIcon fontSize="large"/></a> 
          <a className="github" href='https://github.com/Arijit-101'><GitHubIcon  fontSize="large"/></a>
          <a className="facebook" href='https://www.facebook.com/arijit.saha.33234571'><FacebookOutlinedIcon className="facebook" fontSize="large" /></a>
          <a className="gmail" href='mailto:arijitsaha3002@gmail.com'><MailOutlineIcon fontSize="large"/></a>
         
        </div>

      </div>
    </div>
  );
}

export default App;
